import { parseCountry as e } from "./parse-country.mjs";
const c = (o) => `Field "${o}" is not supported`, d = ({
  value: o,
  field: r,
  countries: s,
  defaultCountry: p
}) => {
  if (["regions", "priority"].includes(r))
    throw new Error(c(r));
  const u = s.find((t) => {
    const n = e(t);
    return o === n[r];
  }) || s.find((t) => {
    const n = e(t);
    return p.toLocaleLowerCase() === n[r];
  });
  if (u)
    return e(u);
};
export {
  d as getCountry
};
